import { Activity, FunctionComponent, memo, RefObject } from 'react';

import styles from '../custom-select.module.css';

import { TReactSelectOption } from '@ui/select/react-select/custom-react-select.types';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';

type CustomSelectFocusedItemsProps = {
  handlePreventDefaultClick: (e: React.MouseEvent<HTMLElement>) => void;
  handleToggleMenu: () => void;
  selectedOptions: TReactSelectOption[];
  selectedOptionsRef: RefObject<HTMLDivElement | null>;
  RenderFocusedLabelContent?: FunctionComponent<{ option: TReactSelectOption; idx: number }>;
  lockActiveState: boolean;
  handleRemoveClick: (option: string | number) => (e: React.MouseEvent<HTMLSpanElement>) => void;
};

const CustomSelectFocusedItems = memo(
  ({
    handlePreventDefaultClick,
    handleToggleMenu,
    selectedOptions,
    selectedOptionsRef,
    RenderFocusedLabelContent,
    lockActiveState,
    handleRemoveClick,
  }: CustomSelectFocusedItemsProps) => {
    return (
      <Activity mode={selectedOptions.length && lockActiveState ? 'visible' : 'hidden'}>
        <div
          className={`flex ai-center gap-12 ${styles.selectedOptions}`}
          onPointerDown={handlePreventDefaultClick}
          onClick={handleToggleMenu}
          ref={selectedOptionsRef}
        >
          {selectedOptions.map((so, idx) => {
            return (
              <div
                key={so.value}
                data-custom-select-selected-option={so.value}
                className={`flex ai-center jc-flex-start gap-8 ${styles.selectedOption}`}
              >
                {RenderFocusedLabelContent ? (
                  <RenderFocusedLabelContent option={so} idx={idx} />
                ) : (
                  <span>{so.label}</span>
                )}

                <span
                  inert={!lockActiveState}
                  role="button"
                  aria-label={`Remove option ${so.label}`}
                  className={styles.removeOptionBtn}
                  onPointerDown={handlePreventDefaultClick}
                  onClick={handleRemoveClick(so.value)}
                  data-remove-option
                  data-remove-option-active="false"
                  data-remove-option-idx={idx}
                  data-remove-option-value={so.value}
                >
                  <Icon size={9} name={ICONS.CLOSE} color="var(--local-chip-default-icotext)" />
                </span>
              </div>
            );
          })}
        </div>
      </Activity>
    );
  }
);

CustomSelectFocusedItems.displayName = 'CustomSelectFocusedItems';

export default CustomSelectFocusedItems;
